import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './slices/user-slice';
import paymentReducer from './slices/payment-slice';

const rootReducer = combineReducers({
  user: userReducer,
  payment: paymentReducer
});

export default rootReducer;
